export default __webpack_public_path__ + "static/logo-af68d6b46b2fd6259f1d4b5a378b502f.svg";